import ApiService from "../../../common/api.service";
import { Message } from "element-ui";

export async function GetConversionPoint({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("CONVERSION_POINT_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/loyalty/config", option);
    commit("CONVERSION_POINT_SUCCESS", _response.data);
  } catch (error) {
    commit("CONVERSION_POINT_ERROR", { result: error.message });
  }
}

export async function UpdateConversionPoint({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("UPDATE_CONVERSION_POINT_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.post("/v1/loyalty/config/upsert", form);
    Message({
      message: "Updated completed",
      type: "success"
    });
    commit("UPDATE_CONVERSION_POINT_SUCCESS", _response.data);
  } catch (error) {
    commit("UPDATE_CONVERSION_POINT_ERROR", { result: error.message });
  }
}
